interface MonthlyUsageInput {
  /** useIndiaComplianceFirstRun().isLoading */
  isFirstRunLoading: boolean
  /** useIndiaComplianceFirstRun().isFirstRun — already India-scoped by the hook. */
  isFirstRun: boolean
}

/**
 * Whether the Monthly Usage card should render with no number at all.
 *
 * An India org that hasn't started KYC yet is still on free-trial credits, so it
 * has no billed monthly usage — the card would otherwise show a confident
 * "₹0 of ₹<default limit>" for an allowance that doesn't apply to it yet.
 * Blank is the honest state until KYC clears and real usage exists.
 *
 * Same shape as shouldRequireKycBeforeCredits: isFirstRun reads true while the
 * numbers/applications counts are in flight, so it is only trusted once the
 * counts have settled. Non-India orgs get false from the hook and are unaffected.
 */
export const shouldBlankMonthlyUsage = ({
  isFirstRunLoading,
  isFirstRun,
}: MonthlyUsageInput): boolean => !isFirstRunLoading && isFirstRun
